<template>
    <div class="ProfileBar">
        <div
            class="ProfileBar__profile-toggle"
            @click.stop="toggleProfileDropdown"
        >
            <span
                :class="[
                    'ProfileBar__profile-text',
                    showProfileDropdown && 'ProfileBar__profile-text--active'
                ]"
            >
                Hi, <strong>{{ userProfile.first_name }}</strong>
            </span>

            <StreamlineIcon
                class="ProfileBar__arrow-icon"
                :icon="ArrowIcon.icon"
                :stroke="ArrowIcon.color"
                :fill="ArrowIcon.color"
                :size="10"
            />
            <ProfileDropdown
                v-if="showProfileDropdown"
                :user-profile="userProfile"
                @nav-to-profile="$emit('nav-to-profile')"
                @sign-out="e => $emit('sign-out', e)"
            />
        </div>

        <span
            class="ProfileBar__notification-container"
            @click="toggleNotificationDropdown"
        >
            <StreamlineIcon
                class="ProfileBar__notification-icon"
                :icon="alarmIcon"
                :stroke="textGrey"
                fill="transparent"
                :size="20"
            />
        </span>
        <span
            class="ProfileBar__help-container"
            @click="toggleHelpDropdown"
        >
            <StreamlineIcon
                class="ProfileBar__help-icon"
                :icon="questionIcon"
                :stroke="textGrey"
                fill="transparent"
                :size="20"
            />
        </span>
    </div>
</template>
<script>
import ProfileDropdown from './ProfileDropdown.vue';
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import {ArrowUp1, ArrowDown1} from "@reviewpush/streamline-bold/lib/arrows-diagrams/Arrows";
import {AlarmBell} from '@reviewpush/streamline-regular/lib/interface-essential/Alert';
import {QuestionCircle} from '@reviewpush/streamline-regular/lib/interface-essential/Alerts';
import has from 'lodash/has';
import colors from 'style/_colors.scss';

const userValidation = (user) => {
    return has(user, 'first_name')
  && has(user, 'email')
  && has(user, 'role_name')
  && has(user, 'profile_image');
};

export default {
    name: 'ProfileBar',
    components: {
        StreamlineIcon,
        ProfileDropdown
    },
    props: {
        userProfile: {
            type: Object,
            required: true,
            validation: userValidation
        }
    },
    data(){
        return {
            showProfileDropdown: false,

            questionIcon: QuestionCircle,
            alarmIcon: AlarmBell,
            textGrey: colors.textGrey,
        };
    },
    computed: {
        ArrowIcon(){
            return this.showProfileDropdown
                ? {icon: ArrowUp1, color: colors.primary}
                : {icon: ArrowDown1, color: colors.textGrey};
        },
    },
    mounted(){
        document.addEventListener('click', this.hideProfileDropdown);
    },
    destroyed(){
        document.removeEventListener('click', this.hideProfileDropdown);
    },
    methods: {
        hideProfileDropdown(e){
            if(!this.$el.contains(e.target)) {
                this.showProfileDropdown = false;
            }
        },
        toggleProfileDropdown(){
            this.showProfileDropdown = !this.showProfileDropdown;
        },
        toggleNotificationDropdown(){
            console.log("Notification Dropdown"); //TODO Notification Dropdown
        },
        toggleHelpDropdown(){
            console.log("Help"); //TODO Help
        }
    }
};
</script>
<style lang="scss">
    .ProfileBar {
        padding-left: 1rem;
        display: flex;
        align-items: center;

        &__profile-toggle{
            position: relative;
            cursor: pointer;
        }
        &__profile-text {
            color: $text-dark;
            margin-right: 0.5rem;
            &--active {
                color: $primary
            }
        }
        &__help-container,
        &__notification-container {
            cursor: pointer;
            display: flex;
            align-items: center;
        }
        &__notification-icon {
            height: 1.25rem;
            margin: 0 1rem;
        }
        &__help-icon {
            height: 1.25rem;
        }
    }
</style>
